import { Heading, HStack, VStack } from '@chakra-ui/react'

import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'

import SeriesHostCard from './SeriesHostCard'

export default function SeriesHomeTutoredBy({
  hosts,
  worldSlug,
}: {
  hosts: Query[]
  worldSlug: string
}) {
  return (
    <VStack gap="16px" alignItems="stretch">
      <Heading size="xl">Tutored by</Heading>
      <HStack gap="16px" overflowX="auto" alignItems="stretch">
        {hosts.map(host => (
          <SeriesHostCard
            key={`${host(UserQ.id)}`}
            host={host}
            worldSlug={worldSlug}
            hasFixedWidth={hosts.length > 1}
          />
        ))}
      </HStack>
    </VStack>
  )
}
